
export const organizationData = {
  name: "Punto Hispano",
  legalName: "Punto Hispano Holding",
  url: "https://puntohispano.ch",
  logo: "https://lhfezfmidegmuwkdwjzt.supabase.co/storage/v1/object/public/img/LOGOS/Logo%20V1%20-%20Punto%20hispano",
  foundingDate: "2020",
  telephone: "+41797700342",
  email: "info@puntohispano.ch",
  hasMap: "https://www.google.com/maps/place/Punto+Hispano+GmbH/@47.4245,8.5692,17z",
  founders: [
    {
      "@type": "Person",
      "name": "Equipo Punto Hispano"
    }
  ],
  address: {
    streetAddress: "Thurgauerstrasse 117, 1° Planta, Oficina 181",
    addressLocality: "Opfikon",
    addressRegion: "Zürich",
    postalCode: "8152",
    addressCountry: "CH"
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+41797700342",
      contactType: "customer service",
      areaServed: ["CH"],
      availableLanguage: ["Spanish", "German", "English", "Italian"],
      hoursAvailable: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "09:00",
        closes: "18:00"
      }
    }
  ],
  sameAs: [
    "https://www.facebook.com/p/Punto-Hispano-61553177270040/",
    "https://www.instagram.com/puntohispanoch/", 
    "https://www.tiktok.com/@puntohispano.ch"
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Servicios Profesionales Punto Hispano",
    itemListElement: [
      {
        "@type": "Offer",
        name: "Gestoría y Administración Fiscal",
        description: "Servicios completos de gestoría para hispanohablantes en Suiza: creación de empresas, planificación fiscal, declaraciones de impuestos, trámites laborales y sociales.",
        category: "Professional Services",
        areaServed: "Switzerland",
        availableLanguage: ["Spanish", "German"],
        priceRange: "€€"
      },
      {
        "@type": "Offer", 
        name: "Asesoría Legal Especializada",
        description: "Servicios legales integrales: reagrupación familiar, visados, derecho laboral, contratos, derecho de familia, sucesiones y legalizaciones internacionales.",
        category: "Legal Services",
        areaServed: "Switzerland", 
        availableLanguage: ["Spanish", "German", "English"],
        priceRange: "€€€"
      },
      {
        "@type": "Offer",
        name: "Formación en Idiomas",
        description: "Cursos de alemán (A1-C1) e inglés (B1-C1) diseñados específicamente para hispanohablantes. Modalidades presencial, online y empresarial.",
        category: "Education",
        areaServed: "Switzerland",
        availableLanguage: ["Spanish", "German", "English"],
        priceRange: "€"
      },
      {
        "@type": "Offer",
        name: "Seguros y Pensiones",
        description: "Asesoría completa en seguros de salud, 3er pilar (3a y 3b), seguros de vida, hogar, vehículos y empresariales. Optimización fiscal garantizada.",
        category: "Financial Services",
        areaServed: "Switzerland",
        availableLanguage: ["Spanish", "German"], 
        priceRange: "€"
      },
      {
        "@type": "Offer",
        name: "Soluciones Digitales Avanzadas",
        description: "Transformación digital empresarial: diseño web profesional, sistemas CRM personalizados, automatización de procesos e implementación de IA.",
        category: "Technology Services",
        areaServed: ["Switzerland", "Spain", "Latin America"],
        availableLanguage: ["Spanish", "English", "German"],
        priceRange: "€€€"
      },
      {
        "@type": "Offer",
        name: "Alquiler de Vehículos",
        description: "Alquiler de coches, furgonetas y vehículos comerciales con atención personalizada en español. Tarifas competitivas y gestión completa de seguros.",
        category: "Automotive",
        areaServed: "Switzerland",
        availableLanguage: ["Spanish", "German"],
        priceRange: "€€"
      },
      {
        "@type": "Offer",
        name: "Alquiler de Viviendas", 
        description: "Búsqueda personalizada de apartamentos y casas, gestión de visitas, negociación con propietarios y asistencia completa en trámites de alquiler.",
        category: "Real Estate",
        areaServed: "Switzerland",
        availableLanguage: ["Spanish", "German"],
        priceRange: "€"
      }
    ]
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday", 
      opens: "10:00",
      closes: "14:00",
      description: "Sábados con cita previa"
    }
  ],
  geo: {
    latitude: 47.4245,
    longitude: 8.5692
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "160",
    bestRating: "5",
    worstRating: "1"
  },
  award: [
    "Mejor Servicio de Gestoría para Hispanohablantes en Zürich 2023",
    "Empresa Recomendada por la Comunidad Española en Suiza"
  ],
  numberOfEmployees: "15-25",
  paymentAccepted: ["Cash", "Credit Card", "Bank Transfer", "Invoice", "PayPal"],
  currenciesAccepted: ["CHF", "EUR"],
  priceRange: "€€",
  serviceArea: {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates", 
      latitude: 47.4245,
      longitude: 8.5692
    },
    geoRadius: "50000"
  },
  knowsAbout: [
    "Legislación fiscal suiza",
    "Derecho de extranjería Suiza", 
    "Reagrupación familiar",
    "Seguros obligatorios Suiza",
    "3er pilar suiza",
    "Creación empresas Suiza",
    "Trámites laborales Suiza",
    "Idioma alemán para hispanohablantes"
  ],
  slogan: "Tu socio integral para hispanohablantes en Suiza"
};
